import type { ConsultantAccessRow, ConsultantAccessState } from "./types";

export type ConsultantAccessFilter = "all" | ConsultantAccessState;

export function filterConsultantAccess(
  rows: ConsultantAccessRow[],
  query: string,
  state: ConsultantAccessFilter
): ConsultantAccessRow[] {
  const needle = query.trim().toLowerCase();
  return rows.filter((row) => {
    if (state !== "all" && row.access_state !== state) return false;
    if (!needle) return true;
    return [row.display_name, row.email, row.title ?? "", row.primary_practice ?? "", row.role]
      .join(" ")
      .toLowerCase()
      .includes(needle);
  });
}
